import React, {useState, useEffect} from 'react';
import '../App.css';
import {toast} from 'react-toastify';
import {Link} from 'react-router-dom';
import {Select} from 'antd';
import {getRoute} from '../api/routes';
import api from '../Interceptor';
import {useSelector} from 'react-redux';
import User_ExpenseGraph from '../components/User_ExpenseGraph';
import GetCurrencySymbol from '../components/GetCurrencySymbol';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faL,
  faRefresh,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';
import {calculateTotals} from '../utils/calculateTotals';
import {calculateDuration} from '../utils/calculateDuration';
import useProjectExpenses from '../hooks/useProjectExpenses';
import ExpenseGraph from '../components/ExpenseGraph';
const {Option} = Select;

const UserDashboard = () => {
  const access = localStorage.getItem('access');
  // const [loading, setLoading] = useState(false);
  const baseCurrency = localStorage.getItem('baseCurrency');
  const {projectList} = useSelector((state) => state.app);
  const [milestoneList, setMilestoneList] = useState([]);
  // const [expenses, setExpenses] = useState([]);
  const [selectedProject, setSelectedProject] = useState('All');
  const [selectedMilestone, setSelectedMilestone] = useState('All');
  const [selectedDuration, setSelectedDuration] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [netProfit, setNetProfit] = useState(0);

  const {expenses, loading, refetchExpenses} = useProjectExpenses(
    selectedProject,
    selectedMilestone,
    startDate,
    endDate
  );

  useEffect(() => {
    const {income, expense, netProfit} = calculateTotals(expenses);
    setTotalIncome(income);
    setTotalExpense(expense);
    setNetProfit(netProfit);
  }, [expenses]);

  useEffect(() => {
    const {newStartDate, newEndDate} = calculateDuration('all');

    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, []);

  const fetchMilestones = async (projectId) => {
    try {
      const response = await api.get(
        `${getRoute(
          'users',
          'user',
          'milestone',
          false,
          false,
          ''
        )}?projectId=${projectId}`
      );
      setMilestoneList(response.data);
    } catch (error) {
      toast.error('Error fetching milestones', error);
      return null;
    }
  };
  useEffect(() => {
    if (endDate) {
      refetchExpenses();
    }
  }, [endDate]);
  const handleProjectChange = (value) => {
    setSelectedProject(value);
    if (value !== 'All') {
      fetchMilestones(value);
    } else {
      setMilestoneList([]);
    }
  };
  const handleMilestoneChange = (value) => {
    setSelectedMilestone(value);
  };
  const handleDurationChange = (value) => {
    setSelectedDuration(value);

    calculateDuration(selectedDuration);
  };
  const handleRefresh = () => {
    setSelectedDuration('all');
    setSelectedProject('All');
    setSelectedMilestone('All');
  };
  if (loading)
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );

  return (
    <div className="min-h-screen lg:max-h-screen flex flex-col p-3 gap-2 overflow-hidden font-customFont">
      <div className="flex-shrink-0 h-[25px] flex flex-col md:flex-row justify-between items-start md:items-center">
        <div
          style={{fontFamily: 'Noto Serif, sans-serif'}}
          className="mb-4 md:mb-0"
        >
          <h1 className="font-bold text-lg">Dashboard</h1>
          {/* <p className="text-xs text-gray-500 font-semibold">
            View and manage your expenses
          </p> */}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {/* Total Net Income Card */}{' '}
        <div className="group relative overflow-hidden border border-blue-200 bg-gradient-to-br from-blue-50 via-white to-blue-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col sm:col-span-2 lg:col-span-1">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faWallet}
                  className="text-white text-md"
                />
              </div>
              <p className="text-blue-700 text-sm font-semibold uppercase tracking-wide">
                Net Income
              </p>
            </div>
          </div>
          <p className="text-blue-900 text-3xl font-bold mt-1 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{' '}
            <span>{Math.floor(netProfit).toLocaleString()}</span>
            <span className="text-blue-600 text-xl">
              .{netProfit.toFixed(2).split('.')[1]}
            </span>
          </p>
          <p className="text-blue-600 text-xs mt-1 font-medium">
            Total profit after expenses
          </p>
        </div>
        {/* Total Income Card */}{' '}
        <div className="group relative overflow-hidden border border-green-200 bg-gradient-to-br from-green-50 via-white to-green-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col ">
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendUp}
                  className="text-white text-md"
                />
              </div>
              <p className="text-green-700 text-sm font-semibold uppercase tracking-wide">
                Income
              </p>
            </div>
          </div>
          <p className="text-green-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{' '}
            <span>{Math.floor(totalIncome).toLocaleString()}</span>
            <span className="text-green-600 text-xl">
              .{totalIncome.toFixed(2).split('.')[1]}
            </span>
          </p>
          <p className="text-green-600 text-xs mt-1 font-medium">
            Total earnings received
          </p>
        </div>
        {/* Total Expense Card */}{' '}
        <div className="group relative overflow-hidden border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100 shadow-lg transition-all duration-300 rounded-2xl p-4 pb-3 flex flex-col">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendDown}
                  className="text-white text-md"
                />
              </div>
              <p className="text-red-700 text-sm font-semibold uppercase tracking-wide">
                Expense
              </p>
            </div>
          </div>
          <p className="text-red-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{' '}
            <span>{Math.floor(totalExpense).toLocaleString()}</span>
            <span className="text-red-600 text-xl">
              .{totalExpense.toFixed(2).split('.')[1]}
            </span>
          </p>
          <p className="text-red-600 text-xs mt-1 font-medium">
            Total amount spent
          </p>
        </div>
      </div>

      <div className="w-full flex flex-col gap-2">
        {/* Container Box */}
        <div className="w-full rounded-lg bg-white border border-[#E5E7EB] shadow-sm p-3">
          {/* Header Section */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="font-semibold font-customFont">Overview</p>

            {/* Filter Section */}
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto font-customFont">
              {/* Project Filter */}
              <Select
                defaultValue="All"
                id="filterProject"
                value={selectedProject}
                onChange={(value) => handleProjectChange(value)}
                className={`ring-1 rounded-md w-full sm:w-40 ${
                  selectedProject || selectedProject === 'All'
                    ? ''
                    : 'ring-blue-400'
                }`}
              >
                <Option value="All">All Projects</Option>
                {projectList.map((pro) => (
                  <Option key={pro?._id} value={pro?._id}>
                    {pro?.name}
                  </Option>
                ))}
              </Select>

              {/* Milestone Filter */}
              <Select
                defaultValue="All"
                id="filterMilestone"
                value={selectedMilestone}
                disabled={selectedProject === 'All'}
                onChange={(value) => handleMilestoneChange(value)}
                className={`ring-1 rounded-md w-full sm:w-40 ${
                  selectedMilestone || selectedMilestone === 'All'
                    ? ''
                    : 'ring-blue-400'
                }`}
              >
                <Option value="All">All Milestones</Option>
                {milestoneList.map((mile) => (
                  <Option key={mile._id} value={mile._id}>
                    {mile.name}
                  </Option>
                ))}
              </Select>

              {/* Duration Filter */}
              <Select
                defaultValue="All"
                required
                value={selectedDuration}
                onChange={handleDurationChange}
                onBlur={() => {
                  if (!selectedDuration) setSelectedDuration('');
                }}
                className={`ring-1 rounded-md w-full sm:w-40 ${
                  selectedDuration ? 'ring-blue-400' : ''
                }`}
              >
                <Option value="currentweek">This Week</Option>
                <Option value="last12months">Last 12 Months</Option>
                <Option value="last6years">Last 6 Years</Option>
                <Option value="all">All</Option>
              </Select>
              <button
                onClick={handleRefresh}
                className="text-black border border-[#DCE3E3] px-3 py-1 rounded-md flex items-center justify-center w-full md:w-auto"
              >
                <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
              </button>
            </div>
          </div>

          {/* Graph Section - Added explicit height */}
          <div className="mt-4 h-[300px] md:h-[350px] lg:h-[400px]">
            <ExpenseGraph
              selectedProject={selectedProject}
              selectedMilestone={selectedMilestone}
              selectedDuration={selectedDuration}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
